import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { devicesSelector } from '../../selectors/devices';
import { filtersDevicesToUseInQuerySelector } from '../../selectors/filters';
import { getDevicesRequest, setDeviceSelected, setStateDevices } from '../../actions/devices';

import DevicesLoader from './DevicesLoader';

const mapStateToProps = createStructuredSelector({
    devices: devicesSelector,
    filtersToUseInQuery: filtersDevicesToUseInQuerySelector
});
const mapDispatchToProps = {
    getDevicesRequest,
    setDeviceSelected,
    setStateDevices,
};

export default connect(mapStateToProps, mapDispatchToProps)(DevicesLoader);
